import { ArrowForward } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import { CustomImage, CustomText, Logo } from "components";
import Layout from "layouts";
import { useNavigate } from "react-router-dom";
import logoText from "assets/logo/logo-text.svg";
import bgLogo from "assets/logo/bg-logo.svg";

export const LockScreen = () => {
  const history = useNavigate();
  return (
    <Layout variant="empty" bgColor="lightGray">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <CustomImage src={bgLogo} alt="logo text" />
      </div>
      <div className="z-10 relative">
        <Grid
          container
          spacing={2}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <CustomImage className="w-52" src={logoText} alt="logo text" />
          </Grid>
          <Grid
            className="flex items-center"
            item
            onClick={() => history("/login")}
          >
            <CustomText
              className="cursor-pointer"
              variant="h4"
              color="secondary"
              bold
            >
              DISPATCH LOGIN
            </CustomText>
            <IconButton>
              <ArrowForward style={{ fontSize: 32, color: "#003657" }} />
            </IconButton>
          </Grid>
        </Grid>
      </div>
    </Layout>
  );
};
